module.exports = __webpack_public_path__ + "img/mini-bjd.5e5632a6.jpg";